import { render } from "./ExitModal.vue?vue&type=template&id=402e22d5&ts=true"
import script from "./ExitModal.vue?vue&type=script&lang=ts"
export * from "./ExitModal.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__